import { render, staticRenderFns } from "./LiquidadorNomina.vue?vue&type=template&id=507ae2d4&scoped=true"
import script from "./LiquidadorNomina.vue?vue&type=script&lang=js"
export * from "./LiquidadorNomina.vue?vue&type=script&lang=js"
import style0 from "./LiquidadorNomina.vue?vue&type=style&index=0&id=507ae2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ae2d4",
  null
  
)

export default component.exports